.tableComponentContainer {
	min-width: 100%;
	padding: 15px 180px 50px 50px;
}
